export const ERROR_TITLES = {
  settings: {
    update: 'Unable to update settings.',
  },
};

export const SUCCESS_MESSAGES = {
  settings: {
    update: 'Settings updated.',
  },
};
